<div class="terms-container">
  <button (click)="dismiss()" class="back-button">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <span class="title">Terms and Conditions</span>

  <span class="warning">
    The customer must be 18 years or older, have a valid SA ID, Passport or
    Asylum number and an active mobile number (to receive an OTP via SMS)
  </span>

  <div class="terms-text-container">
    <p>
      The customer accepts the Terms and Conditions and gives their consent to
      Pepkor processing their personal information according to the Privacy
      Policy.
    </p>
    <p>
      The Pepkor group of companies (Pepkor Holdings Limited, Registration
      number 2017/221869/06, 36 Stellenberg Road, Parow Industria), wishes to
      email or SMS information to you about our products and services as
      referred to in our external privacy statement.
      <br />
      <br />
      For further information, refer to our Privacy Statement or contact our
      Information Officer, on
      <a href="mailto:popia-io@pepkor.co.za">popia-io&#64;pepkor.co.za</a> or
      <a href="tel:0860900100">0860900100</a>.
      <br />
      To sign and consent, please mark the box.
    </p>

    <!--

  <ol class="terms-list">
    <li>
      This free WiFi service being offered at this location (the "WiFi Service")
      is operated by Refinery, a division of Pepkor Trading (Pty) Ltd
      ("Refinery", "we", "us" or "our") whose registered office is at 36
      Stellenberg Road, Parow Industria, 7493 and whose company registration
      number is 1998/007991/07.
    </li>

    <li>
      By using the WiFi Service and/or checking the "I accept" checkbox on the
      login/registration page you acknowledge that you are 18 years or older and
      you agree to be bound by these terms and conditions (the "Terms"). If you
      do not agree, do not register to use the WiFi Service. We reserve the
      right to modify or amend these Terms at any time. Your continued use of
      the WiFi Service following any revisions to these Terms will confirm that
      you have agreed to the modified or amended terms.
    </li>

    <li>
      You are granted a limited, non-exclusive, non-transferable right to access
      and use the WiFi Service for your personal, non-commercial use only.
      Nothing in these Terms constitutes a transfer of any intellectual property
      rights to you. The WiFi Service is provided "as is" and no warranty is
      made by Refinery of any kind whatsoever, including, but not limited to,
      availability, performance, functionality, security of the WiFi Service or
      that the WiFi Service is fault free.
    </li>

    <li>
      You will only be able to access the WiFi Service if you are within range
      of the WiFi signal for any designated area within the Refinery stores.
    </li>

    <li>
      You are responsible for providing all necessary, compatible hardware and
      software to use the WiFi Service, and you are aware that the availability
      and performance of the WiFi Service are subject to any and all limitations
      connected therewith. We are under no obligation to assist you with any
      support for the WiFi Service.
    </li>

    <li>
      When you are using the WiFi Service you must not act in a way that could
      be unlawful or that could encourage others to act unlawfully. You may not
      infringe intellectual property rights or engage in any criminal offence or
      encourage anyone else to do so. You are responsible for all obligations
      toward third parties you may consent to while using the WiFi Service,
      including but not limited to any obligation to pay fees, costs, royalties
      or other remuneration. You may not transfer the rights and obligations you
      may have according to these Terms to a third party.
    </li>

    <li>
      You may not visit websites providing pornographic, racist, other unethical
      or unlawful information. You may not make contact with or arrange meetings
      with children with any sexual intent. This includes but is not limited to:
      chat software, chat sites, discussion forums and email mailing lists. You
      may not use the WiFi Service to harm or attempt to harm minors in any way.
      You must not undertake any actions that are objectionable, immoral or
      inappropriate. Do not use the WiFi Service to collect email addresses or
      other personal details. Do not use the WiFi Service to send spam or junk
      mail.
    </li>

    <li>
      Do not use the WiFi Service in a way that could affect the WiFi Service,
      the network, or other technology connected to it (for example, do not do
      anything that could affect our provision of the WiFi Service to other
      users or that would affect the devices of our other WiFi Service users).
      Be considerate; in particular, do not upload/download very large files and
      make sure your device is protected by up-to-date anti-virus software to
      protect both yourself and other users.
    </li>

    <li>
      We are offering the WiFi Service for free for the purpose of enabling
      limited access to the Internet. You accept that we do not guarantee access
      to the WiFi Service and agree that there may be occasions when the WiFi
      Service may not be available to you. There may also be times when we
      monitor the types of information and/or the sites accessed or applications
      used over the WiFi Service. We reserve the right to suspend or terminate
      your access to the WiFi Service at any time at our discretion and without
      any responsibility to you or a third party.
    </li>

    <li>
      You agree to indemnify Refinery and/or the Pepkor group of companies
      against any claims, damages, fees, losses, costs or expenses arising
      directly or indirectly out of your use of the WiFi Service and/or any
      breach by you of these Terms, including any content or material that you
      access or make available through your use of the WiFi Service.
    </li>

    <li>
      Refinery is in no way liable for any information, data or content
      received, accessed or transmitted through your use of the WiFi Service.
      You are using the WiFi Service solely at your own risk. You acknowledge
      that the WiFi Service is not secure. You acknowledge that we are not
      responsible for the security of your information (which includes, without
      limitation, data you transmit on the WiFi Service) and similarly are not
      responsible for the accuracy, completeness or timeliness of any
      information obtained through the WiFi Service from the internet.
    </li>

    <li>
      The protection of the personal information that you disclose to us during
      the registration process, including your device's location, IP address and
      browser details, is of utmost importance to us. For more information about
      how we may use your personal information, please read our Privacy Policy.
    </li>

    <li>
      Notwithstanding anything else in these Terms to the contrary and to the
      fullest extent permitted by applicable law, we are in no way liable to you
      or any third party for any claims, damages, fees, losses, costs or
      expenses arising directly or indirectly as a result of the WiFi Service
      being used by you or any other person, being unavailable, not operating as
      expected or causing loss or damage to any data.
    </li>

    <li>
      If any provision in these Terms should be held invalid, void or
      unenforceable by any competent authority, in whole or in part, the
      validity and enforceability of other provisions in these Terms shall not
      be affected.
    </li>

    <li>
      You agree that these Terms shall be governed by and interpreted in
      accordance with the laws of the Republic of South Africa without reference
      to its conflict of law provisions. Any dispute or claim arising out of, or
      in connection to these Terms, which cannot be resolved directly between
      the parties, shall be resolved by the courts of the Republic of South
      Africa.
    </li>

    <li>
      Refinery, a division of Pepkor Trading (Pty) Ltd<br />
      36 Stellenberg Road, Parow Industria, 7493<br />
      Phone: 0860 900 400
    </li>
  </ol>-->
  </div>
</div>
